import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import Image from '../Image';
import css from './ProductCare.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ProductCare = function ProductCare(_ref) {
  var products = _ref.products,
      image = _ref.image,
      imageMobile = _ref.imageMobile;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Image, _objectSpread({
      className: cc([css.image, css.desktop])
    }, image)), /*#__PURE__*/_jsx(Image, _objectSpread({
      className: cc([css.image, css.mobile])
    }, imageMobile)), /*#__PURE__*/_jsxs("header", {
      className: css.header,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.pageTitle,
        children: "Product Care"
      }), /*#__PURE__*/_jsx("p", {
        className: css.pageDescription,
        children: "Tips to extend your product\u2019s Doing Things life"
      })]
    }), /*#__PURE__*/_jsx("ul", {
      className: css.list,
      children: products.length > 0 && products.map(function (_ref2) {
        var title = _ref2.title,
            description = _ref2.description;
        return /*#__PURE__*/_jsxs("li", {
          className: css.item,
          children: [/*#__PURE__*/_jsx("h2", {
            className: css.title,
            children: title
          }), /*#__PURE__*/_jsx("p", {
            className: css.description,
            children: description
          })]
        }, title);
      })
    })]
  });
};

ProductCare.propTypes = {
  image: PropTypes.shape().isRequired,
  imageMobile: PropTypes.shape().isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired
};
export default ProductCare;